import { DefaultButton, IButtonProps } from "@fluentui/react";
import History from "@mui/icons-material/History";
import styles from "./HistoryButton.module.css";

interface ButtonProps extends IButtonProps {
  onClick: () => void;
  text: string | undefined;
  className?: string;
}

export const HistoryButton: React.FC<ButtonProps> = ({ onClick, text, className }) => {
  return (
    <DefaultButton
      text={text}
      onRenderIcon={() => <History fontSize="small" />}
      onClick={onClick}
      className={className}
    />
  );
};
